module.exports = __webpack_public_path__ + "img/fin_09_博士影像.cc3f1e22.jpg";